export const GET_SYSTEM_PARAMETERS = "GET_SYSTEM_PARAMETERS"
export const GET_FAQ_URL = "GET_FAQ_URL"
export const GET_COMPLAINTS_URL = "GET_COMPLAINTS_URL"
export const GET_HOME_PAGE_TEXT = "GET_HOME_PAGE_TEXT"
export const GET_ANNUAL_RETURN_START_YEAR = "GET_ANNUAL_RETURN_START_YEAR"
export const GET_REGISTRATION_TEXT = "GET_REGISTRATION_TEXT"
export const GET_ANNUAL_RETURN_PAGE_TEXT = "GET_ANNUAL_RETURN_PAGE_TEXT"
export const GET_DPC_NOTIFICATION_EMAIL = "GET_DPC_NOTIFICATION_EMAIL"


// WEBPACK FOOTER //
// ./src/actionTypes/systemParameter.js